export const REPAIRS = 'REPAIRS';
export const REPAIRS_BUSY = 'REPAIRS_BUSY';
export const REPAIRS_CREATE_BUSY = 'REPAIRS_CREATE_BUSY';
export const REPAIRS_AUTH_BUSY = 'REPAIRS_AUTH_BUSY';
export const SELECTED_REPAIR = 'SELECTED_REPAIR';
export const SELECTED_REPAIR_DATA = 'SELECTED_REPAIR_DATA';
